module.exports = __webpack_public_path__ + "static/img/MG.5fcd0d8d.svg";